// Visual effects and animations module

export class AnimationManager {
  private observer: IntersectionObserver;

  constructor() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target as HTMLElement;
          target.style.opacity = "1";
          target.style.transform = "translateY(0)";
        }
      });
    });

    this.init();
  }

  private init(): void {
    document.addEventListener("DOMContentLoaded", () => {
      this.initScrollAnimations();
    });
  }

  private initScrollAnimations(): void {
    document
      .querySelectorAll<HTMLElement>(
        ".detail-card, .benefit-card, .founder-card"
      )
      .forEach((card) => {
        card.style.opacity = "0";
        card.style.transform = "translateY(20px)";
        card.style.transition = "all 0.6s ease";
        this.observer.observe(card);
      });
  }

  // Method to add new elements to animation observer
  public observeElement(element: HTMLElement): void {
    element.style.opacity = "0";
    element.style.transform = "translateY(20px)";
    element.style.transition = "all 0.6s ease";
    this.observer.observe(element);
  }

  // Cleanup method
  public destroy(): void {
    this.observer.disconnect();
  }
}
